import {FormattedMessage, injectIntl} from "react-intl";
import React, {useEffect, useState} from "react";
import Table from "@amzn/meridian/table";
import TableRow from "@amzn/meridian/table/table-row";
import TableCell from "@amzn/meridian/table/table-cell";
import Heading from "@amzn/meridian/heading";
import Row from "@amzn/meridian/row";
import {fetchAttributesForNode} from "../../NetworkUtils";

const NodeSummary = () => {
    const [dataList, setDataList] = useState([]);
    const [sortColumn, setSortColumn] = useState("name");
    const [sortDirection, setSortDirection] = useState("ascending");

    useEffect(() => {
        fetchAttributesForNode().then(response => setDataList(response));
    }, []);

    const onSort = (sortDetails) => {
        setSortDirection(sortDetails.sortDirection);
        setSortColumn(sortDetails.sortColumn);
        const sortedDataList = [...dataList];
        sortedDataList && sortedDataList.sort((a, b) => {
            if (a[sortColumn] < b[sortColumn]) {
                return sortDirection === "ascending" ? -1 : 1
            }
            if (a[sortColumn] > b[sortColumn]) {
                return sortDirection === "ascending" ? 1 : -1
            }
            return 0
        })
        setDataList(sortedDataList);
    }

    return (
        <div className="App">
            <Row widths={["grid-12"]} alignmentVertical="top" spacingInset="none none medium large">
                <Heading level={2} alignment="left">
                    <FormattedMessage id="nodeSummary.heading" defaultMessage="Node Summary"/>
                </Heading>
            </Row>
            <Row widths={["grid-11"]} alignmentVertical="top" className="enable-scroll-x" spacingInset="none none none large">
                <Table headerRows={1} spacing="small"
                       sortColumn={sortColumn}
                       sortDirection={sortDirection}
                       onSort={onSort}>
                    <TableRow>
                        <TableCell sortColumn="name">
                            <FormattedMessage id="nodeStatus.name" defaultMessage="Name"/>
                        </TableCell>
                        <TableCell sortColumn="type">
                            <FormattedMessage id="nodeStatus.type" defaultMessage="Type"/>
                        </TableCell>
                        <TableCell sortColumn="updatedAt">
                            <FormattedMessage id="nodeStatus.updatedAt" defaultMessage="Last Updated At"/>
                        </TableCell>
                        <TableCell sortColumn="status">
                            <FormattedMessage id="nodeStatus.status" defaultMessage="Status"/>
                        </TableCell>
                    </TableRow>
                    {
                        dataList.map(data => (
                            <TableRow>
                                <TableCell>{data.name}</TableCell>
                                <TableCell>{data.type}</TableCell>
                                <TableCell>{data.updatedAt}</TableCell>
                                <TableCell>{data.status}</TableCell>
                            </TableRow>
                        ))
                    }
                </Table>
            </Row>
        </div>
    );
}

export default injectIntl(NodeSummary);


// WEBPACK FOOTER //
// ./src/components/node-summary/NodeSummary.js